import { useNavigate } from 'react-router-dom';
/** Services Import */
import Commons from '../../Services/Common/Common';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import BasicButton from '../../Components/Button_Basic';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import GridModal from '../../Components/Modal_Grid';
import Dialog from '../../Services/Common/Dialog';
import BasicModal from '../../Components/Modal_Basic';
import Checking from '../../Components/Checking';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import agCheckbox from '../../Components/agGrid/ag-Checkbox';
import React, { useState, useMemo } from 'react';

function BM10020(props) {
    const navigate = useNavigate();
    const [modalToggle, setModalToggle] = React.useState(false);
    const [checkModalToggle, setCheckModalToggle] = React.useState(false);
    const [selectedRowData, setSelectedRowData] = React.useState(null);
    const [selectedModalData, setSelectedModalData] = React.useState(null);
    const [clickAuthGroupData, setClickAuthGroupData] = React.useState(null);
    const gridRef = React.useRef();
    const autoGroupColumnDef = useMemo(() => {
        //그룹설정
        return {
            headerName: '사업장',
            // field: "plantNm",
            minWidth: 200,
            editable: false,
            // cellEditor: "agSelectCellEditor",
            // cellEditorParams: {
            //   values: props.inputs.comboPlantList,
            //   default: props.inputs.comboValue,
            // },
            // valueParser: (params) => {
            //   return props.inputs.comboValue;
            // },
            // valueFormatter: (params) => {
            //   if (params.value == undefined) {
            //     return null;
            //   } else {
            //     return params.value.name;
            //   }
            // },
        };
    }, []);
    // 그리드 컬럼
    const columnDefs = [
        {
            field: 'plantNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '', //사업장
            // rowGroup: true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: props.inputs.comboPlantList,
                default: props.inputs.comboValue,
            },
            valueParser: (params) => {
                return props.inputs.comboValue;
            },
            valueFormatter: (params) => {
                if (params.value == undefined) {
                    return null;
                } else {
                    return params.value.name;
                }
            },
            // hide: true,
        },
        {
            field: 'Password',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ChangePS' && f.lanType === 'COL')[0].lanName
                    : '', //비밀번호변경
            minWidth: 130,
            cellRenderer: (e) => {
                return e.data ? (
                    <BasicButton
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Reset' && f.lanType === 'BTN')[0].lanName
                                : ''
                        }
                        onClick={() => {
                            Dialog.Confirm('초기화', '비밀번호를 초기화 하시겠습니다', '확인', () => {
                                props.UpdatePassword(e.data);
                            });
                        }}
                    />
                ) : (
                    ''
                );
            },
            //   headerCheckboxSelection: true,
            //   checkboxSelection: true,
        },
        {
            field: 'userId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UserId' && f.lanType === 'COL')[0].lanName
                    : '', //아이디
            editable: false,
        },
        {
            field: 'userNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UserNm' && f.lanType === 'COL')[0].lanName
                    : '', //사용자이름
        },
        {
            field: 'authGroupCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_AuthGroupCd' && f.lanType === 'COL')[0].lanName
                    : '', //그룹권한
            cellRenderer: (e) => {
                return e.data ? (
                    e.data.authGroupCd ? (
                        <a style={{ color: 'black' }} onClick={() => AuthGroupSettingClicked(e)}>
                            {e.data.authGroupCd}
                        </a>
                    ) : (
                        <BasicButton
                            name={
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Btn_AuthGoupCdSetting' && f.lanType === 'BTN'
                                      )[0].lanName
                                    : ''
                            }
                            onClick={() => AuthGroupSettingClicked(e)}
                        />
                    )
                ) : (
                    ''
                );
            },
            maxWidth: 300,
            minWidth: 200,
            editable: false,
        },
        // {
        //   field: "authMember",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_AuthMember" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //사용자권한
        //   cellRenderer: (e) => {
        //     return (
        //       <BasicButton
        //         name={
        //           props.lanData.length > 0
        //             ? props.lanData.filter(
        //                 (f) =>
        //                   f.lanId === "Btn_AuthMemberSetting" && f.lanType === "BTN"
        //               )[0].lanName
        //             : ""
        //         }
        //         onClick={() => {
        //           navigate("/BaseManagement/BM10030");
        //         }}
        //       />
        //     );
        //   },
        //   minWidth: 200,
        // },
        {
            field: 'useYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UseYn' && f.lanType === 'COL')[0].lanName
                    : '', //사용유무
            cellRenderer: (e) => {
                return e.data ? agCheckbox(e) : '';
            },
            editable: false,
        },
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '', //생성자
        },
        {
            field: 'createDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateDate' && f.lanType === 'COL')[0].lanName
                    : '', //생성일자
        },
        {
            field: 'updateId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateId' && f.lanType === 'COL')[0].lanName
                    : '', //수정자
        },
        {
            field: 'updateDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateDate' && f.lanType === 'COL')[0].lanName
                    : '', //수정일자
        },
        {
            field: 'print',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Print' && f.lanType === 'COL')[0].lanName
                    : '', //인쇄
            cellRenderer: (e) => {
                return e.data ? (
                    <BasicButton
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Print' && f.lanType === 'BTN')[0].lanName
                                : ''
                        }
                        onClick={() => {
                            props.Print(e);
                        }}
                    />
                ) : (
                    ''
                );
            },
        },
    ];
    // 그룹권한 설정 컬럼
    const AuthGroupGridColumnDef = [
        {
            field: 'authGroupCd',
            headerName: '그룹코드',
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        {
            field: 'authGroupNm',
            headerName: '그룹코드 명',
        },
    ];

    const AuthGroupSettingClicked = (_data) => {
        setSelectedRowData({ ..._data.data });
        props.GetGroup();
        setModalToggle(true);
        setClickAuthGroupData(_data);
    };

    React.useEffect(() => {
        document.title = '사용자관리';
        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '기초관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>사용자관리</strong>" +
            '</h1>';
        if (props.checkInputs.result) {
            gridRef.current.api.setRowData([
                {
                    userId: props.checkInputs.value1,
                    useYn: true,
                },
                ...props.rowData,
            ]);
            props.setSaveUserId([
                {
                    userId: props.checkInputs.value1,
                },
            ]);
            props.setCheckInputs({
                ...props.checkInputs,
                value1: '',
                result: false,
            });
        }
    }, [props.checkInputs.result]);

    return (
        <div>
            <Section />
            <Card
                wrapStyle={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}
            >
                {/* 그리드 버튼 */}
                <AuthGroupButton
                    pageName="BM10020"
                    target="G01"
                    refreshFunc={() => props.Init()}
                    addFunc={() => setCheckModalToggle(true)}
                    saveFunc={() => props.SaveConfirm()}
                    deleteFunc={() => props.DeleteConfirm()}
                />
            </Card>
            <Section />
            <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                {/* 그리드 */}
                <AgGridReact
                    ref={gridRef}
                    animateRows={true}
                    columnDefs={columnDefs}
                    // groupIncludeTotalFooter={true}
                    // autoGroupColumnDef={autoGroupColumnDef}
                    defaultColDef={{
                        flex: 1,
                        minWidth: 100,
                        editable: true,
                        resizable: true,
                        sortable: true,
                        filter: true,
                        floatingFilter: true,
                    }}
                    rowData={props.rowData}
                    cellDataType={false}
                    rowSelection="multiple"
                    onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                    // suppressRowClickSelection={true}
                    onCellValueChanged={(e) => GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)}
                    // getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                    // suppressAggFuncInHeader={true}
                    enableCellChangeFlash={true}
                />
            </div>
            {/* 그룹권한 그리드 */}
            {modalToggle && (
                <GridModal
                    name="그룹권한 설정"
                    onClose={() => setModalToggle(false)}
                    gridColumn={AuthGroupGridColumnDef}
                    gridRowData={props.authGroupGridRowData}
                    buttonName1="저장"
                    gridRowSelection={'multiple'}
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push(e[i].authGroupCd);
                        }
                        setSelectedModalData(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    gridFirstRender={(e, ref) => {
                        let splitData = clickAuthGroupData.data.authGroupCd
                            ? clickAuthGroupData.data.authGroupCd.split(',')
                            : '';
                        setTimeout(() => {
                            ref.current.api.forEachNode(function (node) {
                                for (let i = 0; i < splitData.length; i++) {
                                    if (node.data.authGroupCd === splitData[i]) {
                                        node.setSelected(true);
                                    }
                                }
                            });
                        }, 100);
                    }}
                    execLogic={() => {
                        let data = {
                            ...selectedRowData,
                            authGroupCd: selectedModalData,
                        };
                        props.CreateGroupMember(data);
                    }}
                />
            )}
            {/* 코드 체크 팝업 */}
            {checkModalToggle && (
                <BasicModal
                    name={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Dia_UserManageMent' && f.lanType === 'DIALOG')[0]
                                  .lanName
                            : ''
                    }
                    onClose={() => setCheckModalToggle(false)}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Check' && f.lanType === 'BTN')[0].lanName
                            : ''
                    }
                    execLogic={(e) => {
                        props.CheckUserId();
                    }}
                >
                    <Checking
                        datas={[
                            {
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Dia_UserId' && f.lanType === 'DIALOG'
                                          )[0].lanName
                                        : '',
                                value: props.checkInputs.value1,
                                onChange: (e) => {
                                    props.setCheckInputs({
                                        ...props.checkInputs,
                                        value1: e.target.value,
                                    });
                                },
                            },
                        ]}
                    />
                </BasicModal>
            )}
        </div>
    );
}

export default BM10020;
